import { Overlay, OverlayConfig, OverlayRef } from '@angular/cdk/overlay';
import { PortalModule, TemplatePortalDirective } from '@angular/cdk/portal';
import { Component, OnDestroy, ViewChild, ViewContainerRef } from '@angular/core';
import { Subject, takeUntil } from 'rxjs';
import { TaskProgressionService } from 'src/app/services/task-progression.service';

@Component({
    selector: 'app-server-progress-bar-spinner',
    imports: [PortalModule],
    templateUrl: './server-progress-bar-spinner.component.html',
    styleUrl: './server-progress-bar-spinner.component.scss'
})
export class ServerProgressBarSpinnerComponent implements OnDestroy {
    @ViewChild('progressBarTemplate') progressBarTemplate: TemplatePortalDirective;

    /**
     * Utilisé pour gérer la désincription des observables lorsque le composant est détruit.
     */
    protected componentDestroyed$: Subject<void> = new Subject<void>();

    private overlayRef: OverlayRef;

    private currentProgress = 0;

    private targetProgress = 0;

    public progressText = '';

    private animationFrameId: number | null = null;

    private done: boolean = false;

    /**
     * Constructeur
     */
    constructor(
        public overlay: Overlay,
        public viewContainerRef: ViewContainerRef,
        private taskProgressionService: TaskProgressionService
    ) {
        taskProgressionService.onTaskProgressionChanged$.pipe(takeUntil(this.componentDestroyed$)).subscribe((x) => {
            if (x) {
                console.log('Progression change', x.ProgressValue);
                this.targetProgress = x.ProgressValue; // Met à jour la cible
                this.progressText = x.ProgressText;
                this.done = x.done;

                if (!this.animationFrameId) {
                    this.animate();
                }
            }
        });
    }

    /**
     * Détruit le composant.
     */
    ngOnDestroy(): void {
        this.componentDestroyed$.next();
        this.componentDestroyed$.complete();
    }

    animate() {
        console.log('animate');

        this.animationFrameId = requestAnimationFrame(() => {
            console.log('requestAnimationFrame', this.currentProgress);
            const step = 2; // Etape de 1%

            if (Math.abs(this.currentProgress - this.targetProgress) < Math.abs(step)) {
                this.currentProgress = this.targetProgress; // Atteindre la valeur finale
                document.documentElement.style.setProperty('--progress-value', this.currentProgress.toString());
                this.animationFrameId = null; // Réinitialiser l'ID de l'animation
                console.log('progressValue', this.currentProgress);

                if (this.done) {
                    this.closeProgressBarPanel();
                }
            } else {
                this.currentProgress += step;
                document.documentElement.style.setProperty('--progress-value', this.currentProgress.toString());
                console.log('progressValue', this.currentProgress);
                this.animate(); // Continue l'animation
            }
        });
    }

    openProgressBarPanel() {
        this.currentProgress = 0;
        this.targetProgress = 0;

        let config = new OverlayConfig();

        config.positionStrategy = this.overlay.position().global().centerHorizontally().centerVertically();

        config.hasBackdrop = true;

        this.overlayRef = this.overlay.create(config);

        this.overlayRef.attach(this.progressBarTemplate);
    }

    closeProgressBarPanel() {
        if (this.overlay) {
            this.overlayRef.dispose();
        }
    }
}
